//客户案例2020.7.3更新版
import React from 'react';
import '../CSS/style.css';
import {Col, Row} from "antd";
import casePic from '../Home/img/case.png';
import bigDataApplication from '../Home/img/bigDataApplication.png';
import bigDataApplication2 from '../Home/img/bigDataApplication2.png';
import intelligentApplication from '../Home/img/intelligentApplication.png';
import IOTApplication from '../Home/img/IOTApplication.png';
import { scrollToTop } from './../Utils/CommonFunc';
import { titleSize, subtitleSize, contentSize } from './../Utils/CommonVar';

export default class CustomerCase extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ifShowImage: true,
        }
    }
    componentWillMount() {
        scrollToTop(0);
    }

    componentDidMount() {
        if(this.props.location.state) {
            setTimeout(() => {
                const name = this.props.location.state.name;
                let height = 0;
                if (name === '智能化应用平台') {
                    height = document.getElementById("intelligence").getBoundingClientRect().top - 70;//getBoundingClientRect()用于获取某个元素相对于视窗的位置
                }else if (name === '大数据分析平台') {
                    height = document.getElementById("bigData").getBoundingClientRect().top - 70;
                }else if (name === '物联网应用平台') {
                    height = document.getElementById("intOfThings").getBoundingClientRect().top - 70;
                }
                scrollToTop(height);
            }, 300);
        }else {
            scrollToTop(0);
        }
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.setIfShowImage(width);
        window.onresize = () => {
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            this.setIfShowImage(width);
        };
    }
    setIfShowImage = (width) => {
        if (width < 1100) {
            this.setState({ ifShowImage: false })
        } else {
            this.setState({ ifShowImage: true })
        }
    };

    render() {
        const { ifShowImage } = this.state;
        const width = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) - 17;
        const height = width / 4;
        return(
            <div style={{marginTop:72}}>
                {/*banner*/}
                <div style={{maxHeight:474, zIndex: 2, position: 'relative'}}>
                    <img src={casePic} alt='picture' width={width} height={height}/>
                </div>
                {/*part 1*/}
                <div id="intelligence">
                    <Row type="flex" justify="center" style={{ backgroundColor: '#F2F6F9' }} id="div1">
                        <Row type="flex" align="middle" style={{ width: 1200, height: 398, padding: '64px 0' }}>
                            <Col span={ifShowImage ? 12 : 20}>
                                <Row
                                    type="flex"
                                    justify={ifShowImage ? 'start' : 'center'}
                                    align="middle"
                                    style={{ height: 'auto', paddingLeft: 60 }}
                                >
                                    <div style={{ width: 476 }}>
                                        <div style={{fontSize: titleSize}}>智能应用</div>
                                        <div style={{fontSize: subtitleSize,marginBottom:30}}>AI Application</div>
                                        <div><p style={{lineHeight:3, fontSize: 20 }}>人像摄影-影像后期智能服务平台</p></div>
                                        <div style={{color:'#999999',lineHeight:2, fontSize: contentSize}}>
                                            智能化影像后期制作，快速高效呈现影楼级品质。集中式高效制作提升人像摄影企业核心竞争力，多种服务模式推动摄影行业高品质发展。
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                            <Col span={ifShowImage ? 12 : 0}>
                                <Row type="flex" justify="end" align="middle" style={{ width: 600, paddingRight: 60 }}>
                                    <img style={{boxShadow:'0 4px 16px -4px rgba(133,133,133,0.8)'}} src={intelligentApplication} alt="picture" width={500} />
                                </Row>
                            </Col>
                        </Row>
                    </Row>
                </div>
                {/*part 2*/}
                <div id="bigData">
                    <Row type="flex" justify="center" style={{ backgroundColor: '#fff'}}>
                        <Row style={{ width: 1200, padding: '64px 0' }}>
                            {/*<Col span={ifShowImage ? 3 : 2} />*/}
                            <Col span={ifShowImage ? 12 : 0} >
                                <Row type="flex" justify="end" align="middle" style={{width: 600, paddingRight: 40}}>
                                    <img style={{boxShadow:'0 4px 16px -4px rgba(133,133,133,0.8)'}} src={bigDataApplication} alt="picture" width={500} />
                                    {/*<img style={{boxShadow:'0 4px 16px -4px rgba(133,133,133,0.8)'}} src={bigDataApplication2} alt="picture" width={500} />*/}
                                </Row>
                            </Col>
                            <Col span={ifShowImage ? 0 : 1}> </Col>
                            <Col span={ifShowImage ? 12 : 20}>
                                <Row type="flex" justify={ifShowImage ? 'end' : 'center'} align="middle" style={{ height: ifShowImage ? '256px' : 'auto', paddingRight:60 }}>
                                    <div style={{ width: 476 }}>
                                        <div style={{fontSize: titleSize}}>大数据应用</div>
                                        <div style={{fontSize: subtitleSize,marginBottom:30}}>Big Data Application</div>
                                        <div><p style={{lineHeight:3, fontSize: 20 }}>公共交通-客流大数据分析应用</p></div>
                                        <div style={{color:'#999999',lineHeight:2, fontSize: contentSize}}>
                                            10亿（TB）级数据小时级处理能力，站点客流预测90%准确率。运营指标快速统计分析，细粒度客流辅助运行图优化，出行链描述区域公共交通出行需求。
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                            <Col span={2} />
                        </Row>
                    </Row>
                </div>
                {/*part 3*/}
                <div id="intOfThings">
                    <Row type="flex" justify="center" style={{ backgroundColor: '#F2F6F9' }}>
                        <Row style={{width: 1200, padding: '64px 0'}}>
                            <Col span={ifShowImage ? 12 : 20}>
                                <Row
                                    type="flex"
                                    justify={ifShowImage ? 'start' : 'center'}
                                    align="middle"
                                    style={{ height: ifShowImage ? 300 : 'auto', paddingLeft: 60 }}
                                >
                                    <div style={{ width: 476 }}>
                                        <div style={{fontSize: titleSize}}>物联应用</div>
                                        <div style={{fontSize: subtitleSize,marginBottom:30}}>IOT Application</div>
                                        <div style={{color:'#999999',lineHeight:2, fontSize: contentSize}}>
                                            核心功能：设备接入、规则引擎、安全策略；协议类型：MQTT、COAP(s)、HTTP(s)。
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                            <Col span={ifShowImage ? 12 : 0} >
                                <Row type="flex" justify="end" align="middle" style={{height: 303,width: 600, paddingRight: 60}}>
                                    <img style={{boxShadow:'0 4px 16px -4px rgba(133,133,133,0.8)'}} src={IOTApplication} alt="picture" width={500} />
                                </Row>
                            </Col>
                        </Row>
                    </Row>
                </div>
            </div>
        )
    }
}
